import { WorkflowStepType } from "@/constants/workflows/workflowCreate"
import { WFCreateStep } from "@/types/WorkflowCreate/workflowCreate"
import { App } from "@/types/applications"
import { Combine } from "lucide-react"

export const getFormattedDisplayName = (key: string, applications: App[], steps: WFCreateStep[]) => {
  if (key.includes(';')) {
    const [step, name] = key.split(';')
    const selectedStep = steps.find(s => String(s.order).trim() === step.trim())
    const stepNumber = selectedStep ? steps.indexOf(selectedStep) + 1 : undefined

    const appNameHasLogo = applications.find(a => a.name === name)?.logo
    const isTransformation = name === WorkflowStepType.TRANSFORMATION
    return (
      <span className="flex items-center">
        {appNameHasLogo ? <img src={appNameHasLogo} className="mr-2 h-4 max-w-8" /> : null}
        {isTransformation ? <Combine className="mr-2 h-4 w-4" /> : null}
        <span className="flex flex-col items-start justify-center h-7">
          {stepNumber ? (
            <>
              <span className="text-sm">
                Step {stepNumber}
              </span>
              <span className="text-secondary text-xs -mt-1">
                {/* {applications.find(a => a.name === name)?.displayName ?? key} */}
                {getFormattedSubDisplayName(key, applications, name)}
              </span>
            </>
          ) : (
            <span>
              {key}
            </span>
          )}
        </span>
      </span>
    )
  } else {
    return <span>
      {/* {applications.find(a => a.name === key)?.displayName ?? key} */}
      {getFormattedSubDisplayName(key, applications, key)}
    </span>
  }
}

export const getFormattedSubDisplayName = (key: string, applications: App[], name: string) => {
  if (name.includes(WorkflowStepType.TRANSFORMATION) || key.includes(WorkflowStepType.TRANSFORMATION)) {
    return 'Transformation Step'
  } else {
    return applications.find(a => a.name === name)?.displayName ?? key
  }
}
